export const DRILLDOWN_LINK_LABELS = {
	UNIQUE_ISSUES: 'unique issues',
	UNIQUE_CRITICAL_ISSUES: 'unique critical issues',
	TOTAL_ISSUES: 'total issues',
	CRITICAL_ISSUES: 'critical issues',
	CRITICAL_SEVERITY: 'Critical'
} as const;

export const buildViewText = (label: string): string => `View ${label}`;

export const buildViewAriaLabel = (label: string): string => `View ${label} in issues page`;
